'use client';
import React from 'react';

export default function BackgroundFX() {
  return (
    <div style={{position:'fixed',inset:0,zIndex:0,pointerEvents:'none',overflow:'hidden'}}>
      {/* Gold orb */}
      <div style={{
        position:'absolute',top:'-30%',left:'-15%',
        width:'70vw',height:'70vw',borderRadius:'50%',
        background:'radial-gradient(circle, rgba(244,183,40,0.13) 0%, rgba(244,183,40,0.043) 40%, transparent 68%)',
        animation:'drift1 27s ease-in-out infinite',
        willChange:'transform'
      }} />
      {/* Purple orb */}
      <div style={{
        position:'absolute',bottom:'-35%',right:'-20%',
        width:'78vw',height:'78vw',borderRadius:'50%',
        background:'radial-gradient(circle, rgba(139,92,246,0.1) 0%, rgba(139,92,246,0.035) 42%, transparent 70%)',
        animation:'drift2 37s ease-in-out infinite',
        willChange:'transform'
      }} />
      {/* Teal orb */}
      <div style={{
        position:'absolute',top:'20%',right:'8%',
        width:'44vw',height:'44vw',borderRadius:'50%',
        background:'radial-gradient(circle, rgba(45,212,191,0.07) 0%, transparent 62%)',
        animation:'drift3 47s ease-in-out infinite',
        willChange:'transform'
      }} />
      {/* Grain texture */}
      <div style={{
        position:'absolute',inset:'-4%',opacity:0.35,
        animation:'grainShift 9s steps(4) infinite',
        backgroundImage:`url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='140' height='140'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='.35'/%3E%3C/svg%3E")`
      }} />
      {/* Vignette */}
      <div style={{
        position:'absolute',inset:0,
        background:'radial-gradient(120% 90% at 50% 0%, transparent 55%, rgba(8,8,10,0.3) 100%)'
      }} />
    </div>
  );
}
